import { N_DASH } from '@monoimin/constants';

import type { GetPropertyTotalAreaParams } from '@monoimin/sb-types';

export function formatPropertyTotalArea({
  to,
  from,
  locale,
}: GetPropertyTotalAreaParams) {
  const toSquare = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'meter',
  });

  if (to === from && to && from) {
    return `${toSquare.format(+from)}²`;
  }
  if (to && from) {
    return `${toSquare.format(+from)}² ${N_DASH} ${toSquare.format(+to)}²`;
  }
  if (!to && from) {
    return `${toSquare.format(+from)}²`;
  }

  return '';
}

export default formatPropertyTotalArea;
